module.exports = __webpack_public_path__ + "static/media/flooring_lcs_60y_n.fe43dbfb.csv";